import useConstant from 'use-constant'
import { useState } from 'react'
import { useAsync } from 'react-async-hook'
import AwesomeDebouncePromise from 'awesome-debounce-promise'
import { fetchLocations } from './services'

const isPostcode = text => {
  const noSpaceString = text?.replace(/\s/g, '')
  return /\d/.test(noSpaceString)
}

const useAsyncSearch = (fn, inputText) =>
  useAsync(
    async text => {
      if (text.length < 3) {
        return []
      } else {
        return fn(text)
      }
    },

    // Ensure a new request is made every time the text changes (even if it's debounced)
    [inputText]
  )

export const useSearchLocations = () => {
  const [inputText, setInputText] = useState('')
  const [typing, setTyping] = useState(true)

  const searchPostcodes = text => {
    if (isPostcode(text)) {
      setTyping(false)
      const { postcodesPromise } = fetchLocations(text)
      postcodesPromise.then(() => setTyping(true)).catch(() => setTyping(true))
      return postcodesPromise
    }
  }

  const searchPlaces = text => {
    if (isPostcode(text)) return
    setTyping(false)
    const { placesPromise } = fetchLocations(text)
    placesPromise.then(() => setTyping(true)).catch(() => setTyping(true))
    return placesPromise
  }
  // Debounce the original search async function
  const debouncedSearchPostcodes = useConstant(() =>
    AwesomeDebouncePromise(searchPostcodes, 400)
  )

  const debouncedSearchPlaces = useConstant(() =>
    AwesomeDebouncePromise(searchPlaces, 400)
  )

  const postcodes = useAsyncSearch(debouncedSearchPostcodes, inputText)
  const places = useAsyncSearch(debouncedSearchPlaces, inputText)

  return {
    inputText,
    setInputText,
    postcodes,
    places,
    typing,
  }
}
